import React, { Component } from "react";
import Grid from "@react/react-spectrum/Grid/js/Grid";
import GridColumn from "@react/react-spectrum/Grid/js/GridColumn";
import GridRow from "@react/react-spectrum/Grid/js/GridRow";
import Well from "@react/react-spectrum/Well";
import Dialog from "@react/react-spectrum/Dialog";
import Heading from "@react/react-spectrum/Heading";
import DataSection from "../../comps/DataSection/DataSection";
import formFields from "../config/formFields";
import Button from "@react/react-spectrum/Button";
import Link from "@react/react-spectrum/Link";
import Wait from "@react/react-spectrum/Wait";
import "../managePage.css";
import { Provider, connect } from "react-redux";
import { Translate } from "react-redux-i18n";
// // import geoPolData from '../../../../registration/config/geoPolData.js';
import { getFormValues } from "redux-form";
import { reduxForm } from "redux-form";
import store from "../../store";
import throwError, { toastPartnerApiFailure } from "../../comps/errorToast";

//Laguage Selector
import { disableLanguageSelectorToggle } from "../../actions/commonActions";
import { setLocaleWithFallback } from "../../actions/index";
import { preferredLanguageName } from "../../i18n/config";
import { isRestrictedSanctionCountry } from "../utils/utils";
// TODO(sanctions-ru-by): RU/BY banner + disabled actions — SANCTIONS_RU_BY_VALIDATION_ENABLED
import RestrictedCountryBanner from "../../components/RestrictedCountryBanner";

class OtherContact extends Component {
  constructor() {
    super();
    window.scrollTo(0, 0);
    this.state = {
      sectionValidation: {},
      popupValidation: {},
    };
  }

  state = {
    formInitialized: false,
  };

  tempStates = {};

  componentDidMount() {
    let initFields = {};
    if (this.props.partnerData) {
      initFields = {
        ...this?.props?.partnerData?.partnerInfo,
        ...this.getGeo(this?.props?.partnerData?.partnerInfo?.billingCountry),
        ...this?.props?.partnerData?.contactInfo,
        active: "Yes",
      };
    }
    if (
      this?.props?.partnerData?.contactInfo &&
      this?.props?.partnerData?.contactInfo?.preferredLanguage
    ) {
      this.setLang(this.props.partnerData.contactInfo.preferredLanguage);
    }
    initFields["additionalContactType"] = initFields["additionalContactType"]
      ? initFields["additionalContactType"].split(";")
      : [];
    this.props.initialize(initFields);
    this.setState({ formInitialized: true });
  }

  setLang = (lang) => {
    const finalLocale = Object.keys(preferredLanguageName).includes(lang)
      ? preferredLanguageName[lang]
      : "en_US";
    store.dispatch(setLocaleWithFallback(finalLocale));
    store.dispatch(disableLanguageSelectorToggle(true));
  };

  getGeo = (billingCountry) => {
    let retObj = { geo: "" };
    Object.keys(this.props.geoPolData).map((key) => {
      let obj = this.props.geoPolData[key];
      if (obj.countries.hasOwnProperty(billingCountry)) {
        retObj.geo = obj.value;
      }
      return null;
    });
    return retObj;
  };

  updateValidation = (name, value) => {
    let sectionValidation = this.state.sectionValidation;
    sectionValidation[name] = value;
    this.setState({ sectionValidation: sectionValidation });
  };

  popupValidation = (name, value) => {
    let popupValidation = this.state.popupValidation;
    popupValidation[name] = value;
    this.setState({ popupValidation: popupValidation });
    this.forceUpdate();
  };

  onEditProfileButtonClick() {
    let resetData = {};
    formFields.section15.map((obj) => {
      resetData[obj.name] =
        this.props.formStates[obj.name] !== undefined
          ? this.props.formStates[obj.name]
          : null;
    });
    formFields.section16.map((obj) => {
      resetData[obj.name] =
        this.props.formStates[obj.name] !== undefined
          ? this.props.formStates[obj.name]
          : null;
    });
    this.setState({ resetData: resetData });
  }

  onEditContactSave() {
    let body = {};
    formFields.section15.map((obj) => {
      body[obj.name] = this.props.formStates[obj.name];
    });
    formFields.section16.map((obj) => {
      body[obj.name] = this.props.formStates[obj.name];
    });
    body["additionalContactType"] = body["additionalContactType"].join(";");
    body["active"] = body["active"] === "Yes" ? true : false;
    this.props.isSavingToggle(true);

    this.props.connector.updateContact(
      this.onEditContactSaveComplete,
      body,
      this.props.formStates["accountId"],
      this.props.formStates["contactId"],
    );
  }

  onEditContactCancel() {
    formFields.section15.map((obj) => {
      this.props.change(obj.name, this.state.resetData[obj.name]);
    });

    formFields.section16.map((obj) => {
      this.props.change(obj.name, this.state.resetData[obj.name]);
      if (obj.name == "preferredLanguage") {
        this.setLang(this.state.resetData[obj.name]);
      }
    });
    this.setState({ popupMode: null });
  }

  onEditContactSaveComplete = (response = {}) => {
    if (response?.isError) {
      toastPartnerApiFailure(response);
    } else {
      this.setState({ popupMode: null });
    }
    this.props.isSavingToggle(false);
  };

  render() {
    const formName = "managePartnership";
    const isSanctionRestricted = isRestrictedSanctionCountry(
      this.props?.partnerData?.partnerInfo?.billingCountry,
    );

    return (
      <div>
        {this.state.formInitialized ? (
          <div>
            {this.state.popupMode ? (
              <div className="overlay" style={{ zIndex: "2" }}></div>
            ) : null}
            <div className="page-head">
              <Heading
                style={{
                  paddingLeft: "2%",
                  color: "white",
                  fontSize: "22px",
                  fontWeight: "bold",
                }}
                variant="pageTitle"
              >
                <Translate value="managePartnership.page_heading_other" />
              </Heading>
            </div>

            <div className="page-banner">
              <div className="center">
                <Heading style={{ fontSize: "28px" }}>
                  <Translate value="managePartnership.ConsolePartnerHeader" />
                </Heading>
                <Link
                  style={{ fontSize: "16px" }}
                  href={window.apcConfig.partner.home}
                >
                  <Translate value="managePartnership.go_to_home_page" />
                </Link>
              </div>
            </div>
            <Grid>
              <RestrictedCountryBanner visible={isSanctionRestricted} />
              <GridRow>
                <GridColumn size={[12, 8, 8, 6]} offsetSize={[0, 0, 2, 3]}>
                  <GridRow>
                    <GridColumn>
                      <Heading className="section-heading" variant="subtitle1">
                        <Translate value="managePartnership.ConsolePartnerContactInfoHeader" />
                      </Heading>
                    </GridColumn>
                    <GridColumn>
                      <Button
                        className="button-action margin-action"
                        variant="cta"
                        disabled={isSanctionRestricted}
                        onClick={() => {
                          this.onEditProfileButtonClick();
                          this.setState({ popupMode: "editInfo" });
                        }}
                      >
                        <Translate value="managePartnership.ConsolePartnerBtnEditProfile" />
                      </Button>
                      {this.state.popupMode === "editInfo" ? (
                        <Dialog
                          className="customDialog"
                          variant="confirmation"
                          title={
                            <Translate value="managePartnership.ConsolePartnerBtnEditProfile" />
                          }
                          confirmLabel={
                            <Translate value="managePartnership.TrngSaveClose" />
                          }
                          onConfirm={() => {
                            this.onEditContactSave();
                          }}
                          onCancel={() => {
                            this.onEditContactCancel();
                          }}
                          confirmDisabled={
                            !Object.values(this.state.popupValidation).every(
                              Boolean,
                            )
                          }
                          cancelLabel={
                            <Translate value="managePartnership.TrngClose" />
                          }
                        >
                          <GridColumn>
                            <Provider store={store}>
                              <GridRow>
                                <GridColumn size={[12, 6, 6, 6]}>
                                  <DataSection
                                    field={formFields.section15}
                                    formStates={this.props.formStates}
                                    form={formName}
                                    sectionName="contact1"
                                    updateValidation={this.popupValidation}
                                  />
                                </GridColumn>
                                <GridColumn size={[12, 6, 6, 6]}>
                                  <DataSection
                                    field={formFields.section16}
                                    formStates={this.props.formStates}
                                    form={formName}
                                    sectionName="contact2"
                                    updateValidation={this.popupValidation}
                                  />
                                </GridColumn>
                              </GridRow>
                            </Provider>
                          </GridColumn>
                        </Dialog>
                      ) : null}
                    </GridColumn>
                  </GridRow>

                  <Well className="well-white">
                    <GridRow>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          field={formFields.page2_section1}
                          mode="nonEditable"
                          formStates={this.props.formStates}
                          form={formName}
                          sectionName="readOnly1"
                          updateValidation={this.updateValidation}
                        />
                        <DataSection
                          mode="nonEditable"
                          field={formFields.section15}
                          formStates={this.props.formStates}
                          form={formName}
                          sectionName="contact1"
                          updateValidation={this.popupValidation}
                        />
                      </GridColumn>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <DataSection
                          field={formFields.page2_section2}
                          mode="nonEditable"
                          formStates={this.props.formStates}
                          form={formName}
                          sectionName="readOnly2"
                          updateValidation={this.updateValidation}
                        />
                        <DataSection
                          mode="nonEditable"
                          field={formFields.section16}
                          formStates={this.props.formStates}
                          form={formName}
                          sectionName="contact2"
                          updateValidation={this.popupValidation}
                        />
                      </GridColumn>
                    </GridRow>
                  </Well>
                </GridColumn>
              </GridRow>
            </Grid>
          </div>
        ) : (
          <Wait size="L" centered />
        )}
      </div>
    );
  }
}

OtherContact = reduxForm({
  form: "managePartnership",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(OtherContact);

function mapStateToProps(state) {
  return {
    formStates: getFormValues("managePartnership")(state),
    geoPolData: state.common.geoPolData,
  };
}

export default connect(mapStateToProps)(OtherContact);
